import Resource from './Resource';

class Notes extends Resource {
	constructor() {
		super('notes');
		this.dateFields = ['date'];
	}
}

const resource = new Notes();
export default resource;
